var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "204px",
    height: "206px",
    viewBox: "0 0 204 206",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Human") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.952347,203.827642 C131.971652,203.827642 153.518773,193.252866 168.18377,176.509129 C175.90492,167.693518 195.983564,188.101843 199.245579,176.509129 C199.960122,173.969748 209.576386,142.156493 199.245579,113.098606 C181.531004,63.272091 138.865309,0 107.952347,0 C47.74794,0 -28.2943859,184.837972 10.6360315,203.827642 C33.8881073,215.169653 49.141396,178.258955 52.2425107,181.265359 C66.6473956,195.230307 86.2949234,203.827642 107.952347,203.827642 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Configurazione_v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OnBoarding-v2-2-consent",
    transform: "translate(-105.000000, -184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SX-configurazione",
    transform: "translate(80.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Human",
    transform: "translate(25.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.08,
    fill: "#0D6C80",
    transform: "translate(108.139378, 124.110814) scale(-1, 1) translate(-108.139378, -124.110814) ",
    cx: 108.139378,
    cy: 124.110814,
    rx: 81.0945305,
    ry: 81.0898917
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A-Human/Standing",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.382623, 3.605687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head/Front",
    transform: "translate(67.344621, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8880456,51.2084338 C33.941275,51.2084338 37.2338194,40.3800071 42.3772297,34.4376605 C46.0572342,30.1860333 52.3378645,31.4537961 54.1969358,25.5016105 C58.8717374,10.5343052 46.3596662,0 30.0369047,0 C13.7141432,0 2.70834496,9.23889977 0.331948466,23.1274372 C-2.04444803,37.0159746 8.56528416,51.2084338 24.8880456,51.2084338 Z",
    id: "Hair-Back",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(19.343120, 14.245040)",
    fill: "#B28B67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2145676,7.22851346 C34.8048236,15.7764254 34.2593819,37.4589129 28.326885,38.9866631 C25.9609744,39.5959379 20.9208374,38.1034241 15.7911957,35.0143984 L19.011172,57.7715522 L0,57.7715522 L6.54461849,27.2949523 C2.89465183,23.0145565 0.424300879,17.7689033 0.837106527,11.8910109 C2.02653566,-5.04513471 25.6243117,-1.31939847 30.2145676,7.22851346 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.6982152,21.5215072 C47.0623467,22.2034056 39.7396209,25.6714433 33.901393,30.6461251 C33.2115548,30.2802216 32.4201101,30.0728628 31.5789234,30.0728628 C28.8855081,30.0728628 26.7020635,32.19877 26.7020635,34.8212095 C26.7020635,35.891677 27.0658765,36.8794106 27.6796812,37.6735885 C26.5239089,39.5762928 25.7352903,41.5755331 25.476789,43.6307956 C21.4716074,43.6307956 6.85403224,28.4900805 21.4159641,14.2450403 C35.977896,1.59872116e-13 57.0216902,20.3355545 50.6982152,21.5215072 Z",
    id: "Hair",
    fill: "#191847"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom/Skinny-Jeans-1",
    transform: "translate(46.289001, 137.702056)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Leg",
    fill: "#997659",
    points: "34.0616832 8.52651283e-14 63.8702801 97.3602371 78.310308 180.158847 89.6322869 180.158847 74.3740607 8.52651283e-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3977839,0 C25.4224561,53.4560031 23.0396905,81.0295775 22.5865447,85.8862878 C22.1333988,90.7429981 15.9283491,122.234168 1.23864705,181.789244 L13.3030615,177.649659 C36.5187659,123.02884 44.4298502,94.6414361 47.0925158,87.4690701 C49.7551813,80.296704 56.8270888,51.1403473 68.3082382,0 L23.3977839,0 Z",
    id: "Leg",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left-Shoe",
    transform: "translate(0.000000, 172.523265)",
    fill: "#E4E4E4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33106545,5.06172421 C0.443688484,7.42755983 0,9.19755562 0,10.3717116 C0,11.7988163 0.237967755,13.881317 0.713903264,16.6192136 C2.37099508,16.6192136 17.2635583,16.6192136 45.3915929,16.6192136 C46.5526077,12.7845337 45.8824027,10.7143134 43.3809778,10.4085527 C40.8795529,10.102792 38.8015767,9.82671461 37.1470493,9.58032046 L16.380774,0.331271996 C15.9812042,0.153308424 15.5130209,0.332955774 15.3350573,0.732525583 C15.3320856,0.739197635 15.3292064,0.745910475 15.3264205,0.752662176 L13.9915993,3.98757854 L13.9915993,3.98757854 C11.675934,5.0670021 9.79421564,5.60671388 8.34644406,5.60671388 C7.16942272,5.60671388 5.54366369,5.13149822 3.46916695,4.18106692 L3.46994457,4.17936086 C2.67391427,3.81653303 1.73447415,4.16771302 1.37164632,4.96374332 C1.35697991,4.99592087 1.34339514,5.02858053 1.33091485,5.0616674 Z",
    id: "shoe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right-Shoe",
    transform: "translate(74.460424, 172.523265)",
    fill: "#E4E4E4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33106545,5.06172421 C0.443688484,7.42755983 0,9.19755562 0,10.3717116 C0,11.7988163 0.237967755,13.881317 0.713903264,16.6192136 C2.37099508,16.6192136 17.2635583,16.6192136 45.3915929,16.6192136 C46.5526077,12.7845337 45.8824027,10.7143134 43.3809778,10.4085527 C40.8795529,10.102792 38.8015767,9.82671461 37.1470493,9.58032046 L16.380774,0.331271996 C15.9812042,0.153308424 15.5130209,0.332955774 15.3350573,0.732525583 C15.3320856,0.739197635 15.3292064,0.745910475 15.3264205,0.752662176 L13.9915993,3.98757854 L13.9915993,3.98757854 C11.675934,5.0670021 9.79421564,5.60671388 8.34644406,5.60671388 C7.16942272,5.60671388 5.54366369,5.13149822 3.46916695,4.18106692 L3.46994457,4.17936086 C2.67391427,3.81653303 1.73447415,4.16771302 1.37164632,4.96374332 C1.35697991,4.99592087 1.34339514,5.02858053 1.33091485,5.0616674 Z",
    id: "shoe"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    fill: "#5C63AB",
    points: "30.1010223 0 42.775137 49.604016 81.4868878 49.604016 75.7148081 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9718328,0 C18.8016048,12.4885841 18.0094727,29.0232561 20.5954363,49.604016 L60.0993193,49.604016 L70.9620151,0 L22.9718328,0 Z",
    id: "Bottom",
    fill: "#8991DC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body/Long-Sleeve-1",
    transform: "translate(0.000000, 54.195512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.174061,70.5356605 L171.085854,90.7886659 C177.793271,93.1092522 183.344382,95.8012572 187.739185,98.8646809 C188.753626,99.9267338 189.923301,102.015758 185.454012,101.356614 C180.984723,100.69747 176.25403,100.204962 175.526848,101.69286 C174.799666,103.180759 177.390692,105.201888 175.992779,107.180338 C175.060837,108.499305 171.355143,104.769907 164.875697,95.9921467 L140.638831,83.9074939 L147.174061,70.5356605 Z M38.8961113,61.7712623 C27.5034863,92.5136393 20.8224609,109.330287 18.8530351,112.221206 C17.4088343,114.341148 8.11818318,120.093212 1.79039835,123.236636 C-0.749488675,124.498363 -0.076350305,126.663846 0.722743253,127.326077 C7.22239149,132.712521 12.6379367,128.182711 19.2005337,126.184515 C26.3904223,123.99532 24.5744297,132.772494 30.2606698,131.132019 C29.1355113,127.223242 26.2573149,119.839498 28.7046211,115.600262 C29.7923127,113.716157 37.8661765,96.4518503 52.9262123,63.8073425 L38.8961113,61.7712623 Z",
    id: "Skin",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8041313,7.70236748 L102.214315,4.0833311 C116.52751,32.3755331 136.530253,59.2112853 167.900261,80.6120784 L161.752893,93.7227718 C134.700885,80.8326938 109.317789,71.2016561 97.4475365,49.3466793 C93.463573,42.0115841 94.3311888,16.8436075 93.8041313,7.70236748 Z",
    id: "Coat-Back",
    fill: "#89C5CC",
    transform: "translate(130.852196, 48.903051) rotate(5.000000) translate(-130.852196, -48.903051) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6765696,87.4634996 C92.579879,90.10147 112.181515,90.10147 126.481478,87.4634996 C128.253148,87.1366727 128.532652,84.1732026 127.711042,82.1619434 C114.916443,50.8414026 106.142747,23.51247 106.142747,1.75792783 C103.795099,2.94038556 99.6864936,3.11759163 93.8169311,2.28954604 C78.0425709,24.7083012 70.7916593,50.4312577 67.6765696,87.4634996 Z",
    id: "Shirt",
    fill: "#323337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9185492,-1.33226763e-14 L89.895236,0.41 L96.469326,0.410475752 C97.9846913,9.31459325 102.731613,128.773236 117.287766,169.819494 L117.731871,171.039124 L37.0886382,171.039124 C38.8369368,134.541671 52.627958,90.6994159 66.5985494,54.0115538 C54.244525,65.3059139 43.4779214,84.4423834 34.2975924,111.421035 L19.192236,107.547145 C30.4232773,59.1970984 53.5140077,23.6593068 88.4644273,0.933770263 L88.6930897,0.410475752 L89.277236,0.41 L89.9185492,-1.33226763e-14 Z",
    id: "Coat-Front",
    fill: "#C1DEE2"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/Human.2594e71eeffc5fa72788fa487af0e22e.svg";
export { ForwardRef as ReactComponent };